module.exports = __webpack_public_path__ + "img/130.5.d76542ea.png";